import { usePaymentMethodContext, sortPaymentMethods } from "@context/PaymentMethodContext";
import { useNotificationContext } from "@context/NotificationContext";
import setDefaultPaymentMethod from "@api/setDefaultPaymentMethod";
import deletePaymentMethodApi from "@api/deletePaymentMethod";

const useManagePaymentMethods = () => {
  const { setPaymentMethods, refresh } = usePaymentMethodContext();
  const { showSuccess, showError } = useNotificationContext();

  const handleAddCard = async (paymentMethodId: string) => {
    const response = await setDefaultPaymentMethod(paymentMethodId);
    if (response.success) {
      refresh();
      showSuccess("Payment method added successfully");
    } else {
      showError(response.error || "Failed to set default payment method");
    }
  };

  const handleMakePrimary = async (id: string) => {
    const response = await setDefaultPaymentMethod(id);
    if (response.success) {
      setPaymentMethods((prev) =>
        sortPaymentMethods(prev.map((pm) => ({ ...pm, isDefault: pm.id === id }))),
      );
      showSuccess("Default payment method updated");
    } else {
      showError(response.error || "Failed to update default payment method");
    }
  };

  const handleDelete = async (id: string) => {
    const response = await deletePaymentMethodApi(id);
    if (response.success) {
      setPaymentMethods((prev) => prev.filter((pm) => pm.id !== id));
      showSuccess("Payment method deleted");
    } else {
      showError(response.error || "Failed to delete payment method");
    }
  };

  return { handleAddCard, handleMakePrimary, handleDelete };
};

export default useManagePaymentMethods;
